import styled from 'styled-components';
import { inputStyle } from './Input';

const TextArea = styled.textarea`
  ${inputStyle};
`;

export default TextArea;
